import Icons from './utils/Icons';

import Swiper from 'swiper/bundle';

class Main {
  constructor() {
    this.init();
  }

  init() {
    Icons.load();

    this.initSwiperEvents();
    this.initSwiperConferenciers();

    document
      .querySelector('.js-toggle')
      .addEventListener('click', this.onOpenNav);
    document
      .querySelector('.js-close')
      .addEventListener('click', this.onCloseNav);
  }

  onOpenNav() {
    document.documentElement.classList.add('nav-is-active');
  }

  onCloseNav() {
    document.documentElement.classList.remove('nav-is-active');
  }

  initSwiperEvents() {
    const target = document.querySelector('.js-swiper-events');
    if (target) {
      const swiper = new Swiper(target, {
        pagination: {
          el: '.swiper-pagination',
        },
        slidesPerView: 1,
        spaceBetween: 30,
        loop: true,
        breakpoints: {
          768: {
            slidesPerView: 1.2,
          },
        },
      });
    }
  }

  initSwiperConferenciers() {
    const target = document.querySelector('.js-swiper-conferenciers');
    if (target) {
      const swiper = new Swiper(target, {
        pagination: {
          el: '.swiper-pagination',
        },
        slidesPerView: 1.1,
        spaceBetween: 30,
        loop: true,
        breakpoints: {
          768: {
            slidesPerView: 2,
          },
          1024: {
            slidesPerView: 3,
          },
        },
      });
    }
  }
}

new Main();
